import React, { useEffect, useRef, useState } from "react";
import { NavLink, Link, useLocation, useNavigate } from "react-router-dom";
import SidebarLinkGroup from "./SidebarLinkGroup";

import { AiOutlineDown, AiOutlineLeft } from "react-icons/ai";
import {
  APP_URLS,
  LOGO,
  LOGO_DARK,
  USER_ROLES,
  getReadableRole,
} from "../../config";
import { ADMIN_MENU, ASSOCIATE_MENU, HR_MENU, TEAM_LEAD_MENU } from "../menu";
import { useSelector } from "react-redux";
import { userDetailsSelector } from "../../rdxsga/redux/slices/userSlice";
import { useDarkMode } from "../../rdxsga/hooks/common/useDarkMode";
import { SUPER_ADMIN_MENU } from "../menu/superAdmin";
import { Tooltip } from "@material-tailwind/react";
import { isParomita, isSagarika } from "../../helpers/permission/staticPerm";
import { CUSTOMER_SERVICE_MENU } from "../menu/customerService";

const Sidebar = ({ sidebarOpen, setSidebarOpen, handleLogout }) => {
  const location = useLocation();
  const darkMode = useDarkMode();
  const users = useSelector(userDetailsSelector);
  const { pathname } = location;
  const trigger = useRef(null);
  const sidebar = useRef(null);
  const isSuperAdmin =
    users?.user?.role === USER_ROLES.SUPER_ADMIN ||
    users?.user?.role === USER_ROLES.ADMIN;
  const storedSidebarExpanded = localStorage.getItem("sidebar-expanded");

  const [sidebarExpanded, setSidebarExpanded] = useState(
    storedSidebarExpanded === null ? false : storedSidebarExpanded === "true"
  );

  const getUsersMenu = () => {
    if (users?.user?.role === USER_ROLES.SUPER_ADMIN) return SUPER_ADMIN_MENU;
    else if (users?.user?.role === USER_ROLES.ADMIN) return ADMIN_MENU;
    else if (users?.user?.role === USER_ROLES.ASSOCIATE) return ASSOCIATE_MENU;
    else if (users?.user?.role === USER_ROLES.TEAM_LEAD) return TEAM_LEAD_MENU;
    else if (users?.user?.role === USER_ROLES.HR) return HR_MENU;
    else if (users.user.role === USER_ROLES.CUSTOMER_SERVICE) return CUSTOMER_SERVICE_MENU;

    return [];
  };
  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!sidebar.current || !trigger.current) return;
      if (
        !sidebarOpen ||
        sidebar.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setSidebarOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  }, [sidebarOpen]);

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!sidebarOpen || keyCode !== 27) return;
      setSidebarOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });

  useEffect(() => {
    localStorage.setItem("sidebar-expanded", sidebarExpanded.toString());
    if (sidebarExpanded) {
      document.querySelector("body")?.classList.add("sidebar-expanded");
    } else {
      document.querySelector("body")?.classList.remove("sidebar-expanded");
    }
  }, [sidebarExpanded]);

  // //console.log(pathname, APP_URLS.ORGANIZATION.SECURITY)
  return (
    <div
      className={`bg-sidebarbg ${sidebarOpen
        ? `w-[220px] scrollbar `
        : ` ${isSuperAdmin ? "w-[56px] scrollbar" : "w-[50px]"
        }  hover:w-[220px] fixed left-0 z-9999`
        } duration-300 h-screen overflow-x-hidden overflow-y-auto pt-10 pb-20 flex flex-col justify-start items-center`}
    >
      {/* <img src={LOGO_DARK} alt="Logo" className='h-20 object-cover overflow-hidden' /> */}

      {getUsersMenu().map((d, i) => {
        return d.hasSubMenu ? (
          <React.Fragment key={i}>
            {/* <div className={`w-full flex border-whiten items-center py-1 pe-2 cursor-pointer ${pathname === d.path && "bg-theme"}`}> */}
            {/* <d.icon size={20} className='min-w-[50px] text-sidebarbg me-2' /> */}
            {/* <span className='w-auto text-whiten text-'>{d.title}</span> */}
            {/* </div> */}
            <div className="w-full bg-transparent pt-2 border-b-[1px] border-themelight-dark ps-[50px] text-nowrap text-white">
              <span className="w-full flex bg-themelight-dark py-1 rounded-tl px-4">
                {d?.title}
              </span>
            </div>
            {d.submenu.map((dd, j) => {

              return (
                <Link
                  to={dd.path}
                  className={`w-full flex hover:ps-2 duration-200 justify-left items-center py-1 pe-2 cursor-pointer ${pathname === dd.path && "bg-theme"
                    }`}
                  key={j}
                >
                  <dd.icon
                    size={20}
                    className={`min-w-[50px] ${pathname === dd.path ? "text-sidebarbg" : "text-white"
                      } me-2`}
                  />
                  <span
                    className={`w-auto ${pathname === dd.path ? "text-sidebarbg" : "text-white"
                      } text-nowrap overflow-x-hidden`}
                  >
                    {dd.title}
                  </span>
                </Link>
              );

            })}
          </React.Fragment>
        ) : (
          <Link
            to={d.path}
            className={`w-full flex hover:ps-2 duration-200 justify-left items-center py-1 pe-2 cursor-pointer ${pathname === d.path && "bg-theme"
              }`}
            key={i}
          >
            <d.icon
              size={20}
              className={`min-w-[50px] ${pathname === d.path ? "text-sidebarbg" : "text-white"
                } me-2`}
            />
            <span
              className={`w-auto ${pathname === d.path ? "text-sidebarbg" : "text-white"
                } text-nowrap overflow-x-hidden`}
            >
              {d.title}
            </span>
          </Link>
        );
      })}
    </div>
  );
};

export default Sidebar;

// return (
//   <aside
//     ref={sidebar}
//     className={`absolute left-0 top-0 z-9999 flex h-screen w-70 flex-col overflow-y-hidden bg-[#000] duration-300 ease-linear dark:bg-boxdark lg:static lg:translate-x-0 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}
//   >
//     {/* <!-- SIDEBAR HEADER --> */}
//     <div className="flex items-center justify-center gap-0 px-6 py-5.5 lg:py-6.5">
//       <NavLink to={APP_URLS.DASHBOARD}>
//         {/* <img src={darkMode ? LOGO_DARK : LOGO} alt="Logo" className='h-20' /> */}
//         <img src={LOGO_DARK} alt="Logo" className='h-20' />

//       </NavLink>

//       <button
//         ref={trigger}
//         onClick={() => setSidebarOpen(!sidebarOpen)}
//         aria-controls="sidebar"
//         aria-expanded={sidebarOpen}
//         className="block lg:hidden z-10"
//       >
//       </button>
//     </div>
//     {/* <!-- SIDEBAR HEADER --> */}
//     <div className="no-scrollbar flex flex-col overflow-y-auto duration-300 ease-linear">
//       {/* <!-- Sidebar Menu --> */}
//       <nav className="mt-5 py-0 px-4 lg:mt-0 lg:px-6">
//         <h2 className="mb-1 text-center text-lg font-bold text-bodydark">
//           {`${users?.user?.user?.firstName} ${users?.user?.user?.middleName} ${users?.user?.user?.lastName}`}
//         </h2>

//         <h3 className="mb-4 text-center text-md font-semibold text-bodydark">
//           {getReadableRole[users?.user?.role]}
//         </h3>

//         <ul className="mb-6 flex flex-col gap-1.5">
//           {/* <!-- Menu Item Dashboard --> */}
//           {
//             getUsersMenu().map((d, i) => (
//               <div key={i}>
//                 {
//                   d.hasSubMenu ? <SidebarLinkGroup
//                     activeCondition={d?.submenu?.map(d => d?.path)?.includes(pathname)}
//                     key={i}>
//                     {(handleClick, open) => {
//                       return (
//                         <React.Fragment>
//                           <NavLink
//                             data-ripple-light="true"
//                             onClick={(e) => {
//                               e.preventDefault();
//                               sidebarExpanded
//                                 ? handleClick()
//                                 : setSidebarExpanded(true);
//                             }}
//                             className={`group relative flex items-center gap-2.5 rounded ${open && "bg-whiten dark:bg-black"} px-4 py-2 font-medium text-black duration-300 ease-in-out font-bold hover:bg-themelight hover:text-white dark:text-white dark:hover:bg-themelight dark:hover:text-black ${open && 'text-black'}`}>
//                             <d.icon size={20} className='font-extrabold' />
//                             {/* {d.title} */}
//                             <span
//                               className={`absolute right-4 top-1/2 -translate-y-1/2 fill-current duration-300 ${open && '-rotate-90'}`}>
//                               <AiOutlineLeft />
//                             </span>
//                           </NavLink>
//                           {/* <!-- Dropdown Menu Start --> */}
//                           <div className={` ${!open && 'hidden'} bg-whiten dark:bg-black translate transform duration-300 overflow-hidden`}>
//                             <ul className="mt-4 mb-5.5 flex flex-col gap-2.5 pl-6 duration-300">
//                               {
//                                 d.submenu.map((m, i) => (
//                                   <Link
//                                     key={i}
//                                     to={m.path}
//                                     onClick={() => { setSidebarOpen(false) }}
//                                     className={`group relative flex items-center gap-2.5 rounded px-4 py-2 font-medium text-black duration-900 ease-in-out font-bold hover:bg-theme hover:text-white dark:text-white dark:hover:bg-themelight ${m.path === pathname && 'bg-themelight dark:bg-theme'}`}>
//                                     <m.icon className='font-extrabold' />
//                                     {m.title}
//                                   </Link>
//                                 ))
//                               }
//                             </ul>
//                           </div>
//                           {/* <!-- Dropdown Menu End --> */}
//                         </React.Fragment>
//                       );
//                     }}
//                   </SidebarLinkGroup >
//                     :
//                     <li>
//                       {/* without any submenu */}
//                       <Link to={d.path}
//                         onClick={() => setSidebarOpen(false)}
//                         className={`group relative flex items-center gap-2.5 rounded px-4 py-2 font-medium text-black duration-300 ease-in-out font-bold hover:bg-theme hover:text-white dark:text-white dark:hover:bg-themelight ${d.path === pathname && 'bg-themelight dark:bg-theme'}`}>
//                         <d.icon className='font-extrabold' />
//                         {/* {d.title} */}
//                       </Link>
//                     </li>
//                 }
//               </div>
//             ))
//           }
//         </ul>
//       </nav>
//     </div>
//   </aside >
// );
